import { render, staticRenderFns } from "./pureDataList.vue?vue&type=template&id=72c05032&scoped=true"
import script from "./pureDataList.vue?vue&type=script&lang=js"
export * from "./pureDataList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c05032",
  null
  
)

export default component.exports